// extracted by mini-css-extract-plugin
module.exports = {"actions-btns":"ActionBtns_actions-btns__2oOda"};